import type { FinanceInsuranceActionsType } from "../actions/FinanceInsuranceActions";
import {
    RESET_FINANCE_RATES,
    FINISH_FINANCE_RATE_FETCH,
    INIT_FINANCE_QUOTES,
    SET_FINANCE_RATE_FETCH_LOADING,
    START_FINANCE_RATE_FETCH,
    UPDATE_QUOTE_CONFIG,
    SET_FINANCE_COLLAPSABLE_ACTIVE,
    CLEAR_FINANCE_RATE,
    SET_FINANCE_PRODUCT_TYPE,
    FQS_INITIALIZED,
} from "../actions/FinanceInsuranceActions";
import type { CommonFinanceInfoType } from "../../../../../common-deprecated/types/CommonTypes";
import type { QuoteInfoType } from "../../../../../common-deprecated/types/FinanceInsuranceRateTypes";

export type FinanceRateStateType = {
    itemRates: { [index: string]: string };
    fetching: boolean;
    error: boolean;
    total: string;
    totalWithoutPromotions: string;
    // MsgCode is added for usage for the trade-in integration in the build.
    info: CommonFinanceInfoType & { msgCode?: string };
    quotes: {
        finance: string | null;
        insurance: string | null;
        enabled: boolean;
    };
    quoteInfo: QuoteInfoType;
    collapsableActive: boolean;
    financeProductType: string;
    fqsInitialized: boolean;
};

export const initialState: FinanceRateStateType = {
    itemRates: {},
    fetching: false,
    error: false,
    total: "0",
    totalWithoutPromotions: "0",
    info: {
        effectiveInterestRate: "",
        annualInterestRate: "",
        productName: "",
        productType: "",
        term: "",
        msgCode: "",
        disclaimer: {
            value: "",
        },
    },
    quotes: {
        enabled: false,
        finance: null,
        insurance: null,
    },
    quoteInfo: {},
    collapsableActive: false,
    financeProductType: "",
    fqsInitialized: false,
};

const financeReducer = (
    state: FinanceRateStateType = initialState,
    action: FinanceInsuranceActionsType,
): FinanceRateStateType => {
    switch (action.type) {
        case INIT_FINANCE_QUOTES:
            return {
                ...state,
                quotes: { enabled: true, finance: action.financeQuote, insurance: action.insuranceQuote },
            };

        case SET_FINANCE_RATE_FETCH_LOADING:
            return { ...state, fetching: action.loading };

        case START_FINANCE_RATE_FETCH: {
            // Empty quoteInfo props if available
            const quoteInfo: QuoteInfoType = {};

            Object.keys(state.quoteInfo).forEach((key) => {
                quoteInfo[key] = { value: "", formatted: "" };
            });

            return { ...state, fetching: true, error: false, quoteInfo };
        }

        case FINISH_FINANCE_RATE_FETCH: {
            const { rates = {} } = action;

            const { total = "", totalWithoutPromotions = "", quoteInfo = {}, info } = action.result;

            return { ...state, itemRates: rates, fetching: false, info, total, totalWithoutPromotions, quoteInfo };
        }

        case UPDATE_QUOTE_CONFIG: {
            return {
                ...state,
                quotes: { ...state.quotes, ...action.quotes, enabled: true },
                info: { ...state.info, productName: action.data?.productName ?? "" },
            };
        }

        case FQS_INITIALIZED: {
            return { ...state, fqsInitialized: true };
        }

        case RESET_FINANCE_RATES:
            return {
                ...state,
                fetching: false,
                error: true,
                quotes: initialState.quotes,
                quoteInfo: {},
            };

        case SET_FINANCE_COLLAPSABLE_ACTIVE:
            return { ...state, collapsableActive: action.active };

        case SET_FINANCE_PRODUCT_TYPE:
            return { ...state, financeProductType: action.financeProductType };

        case CLEAR_FINANCE_RATE:
            return { ...initialState };

        default:
            return state;
    }
};

export default financeReducer;
